/**
 * Сборка роутера. Здесь только склейка — таблица лежит в `routes.ts`,
 * решения о доступе в `guards.ts`.
 */

import { createRouter, createWebHistory } from 'vue-router'

import { registerGuards } from './guards'
import { routes } from './routes'

const router = createRouter({
  /**
   * `createWebHistory`, а не hash: приложение отдаётся Vite dev-сервером и
   * любым статик-хостом с fallback на `index.html`. Адрес стойки пишут на
   * бумажке и набирают на телефоне руками — `#` в нём лишний.
   */
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

registerGuards(router)

/**
 * Реэкспорт ради `LoginView`: `?redirect=` обязан проходить через общую
 * проверку, а не через локальную копию. Цикла импортов нет — вью подгружаются
 * лениво, уже после того как этот модуль вычислен.
 */
export { safeRedirect } from './guards'
export { routes } from './routes'

export default router
